import React from "react";
import Contact from "../components/contact/Contact";
import Footer from "../components/layout/footer/Footer";
import Navbar from "../components/layout/header/Navbar";
import Layout from "../components/layout/Layout";
import Subsribe from "../components/newsletter/Subsribe";
import PageHeader from "../components/team/PageHeader";
import Teams from "../components/team/Teams";
import BrandCarousel from "../components/testimonial/BrandCarousel";

export default function OurTeam() {
  return (
    <Layout>
      <Navbar darkBg />
      <PageHeader HeaderTitle="News" Parent="Pages" PageTitle="News" />
      <section className="promo-section mt-5 ptb-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-10">
            
             
            </div>
         
          
          </div>
          <p>Interested in joining the Sustainable Institute? Send us an email to join@si2.com with
your CV or Resume. Please attached a letter including an outline of your expertise, a
list of languages you are fluent in, and the country or region you specialize in. Once
received, we will review your documents and include you in our global database,
Team of Experts. As soon as the need arises for your specialisation, our Team will
contact you. We are always interested in hearing from you!</p>
   
        </div>
      </section>
      <Contact bgColor="gray-light-bg" />

      <Footer space />
    </Layout>
  );
}
